import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";

export default function(){

    return new Style({
        stroke: new Stroke({
            color: 'grey',
            width: 1,
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 0, 0)',
        }),
    });
}